import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import AlfatekLogo from "@/components/AlfatekLogo";

export default function AdminLogin() {
    const { user, login, ready } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("admin@alfatek.com.br");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (ready && user) nav("/admin", { replace: true });
    }, [ready, user, nav]);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        const r = await login(email, password);
        setLoading(false);
        if (r.ok) {
            toast.success("Bem-vindo(a)");
            nav("/admin", { replace: true });
        } else {
            setError(r.error);
        }
    };

    return (
        <div className="min-h-screen grid lg:grid-cols-2 bg-white">
            <div className="hidden lg:block relative bg-brand-blue-deep overflow-hidden">
                <div className="absolute inset-0 grid-blueprint opacity-40" />
                <div className="absolute inset-0 bg-gradient-to-br from-brand-blue-deep to-brand-blue/70" />
                <div className="relative h-full flex flex-col justify-between p-12">
                    <AlfatekLogo className="h-10" />
                    <div>
                        <div className="text-xs font-mono uppercase tracking-[0.28em] text-brand-yellow mb-4">Painel administrativo</div>
                        <h2 className="font-heading font-black text-white text-5xl leading-tight tracking-tight">
                            Cinco marcas.<br />Um cockpit.
                        </h2>
                        <p className="mt-4 text-neutral-300 max-w-md">Controle produtos, marcas, categorias e leads do catálogo ALFATEK.</p>
                    </div>
                    <div className="font-mono text-xs text-neutral-400">v0.1 · fase 0 + 1</div>
                </div>
            </div>

            <div className="flex items-center justify-center p-8">
                <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
                    <div className="lg:hidden mb-8"><AlfatekLogo className="h-9" /></div>
                    <div className="text-xs font-mono uppercase tracking-[0.24em] text-neutral-500">Acesso restrito</div>
                    <h1 className="mt-2 font-heading font-black text-3xl tracking-tight">Entrar no painel</h1>

                    <div className="mt-8 space-y-4">
                        <div>
                            <label className="text-xs font-mono uppercase tracking-widest text-neutral-500">E-mail</label>
                            <input
                                data-testid="login-email"
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="mt-1 w-full h-12 px-4 bg-white border border-neutral-300 focus:outline-none focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/20"
                            />
                        </div>
                        <div>
                            <label className="text-xs font-mono uppercase tracking-widest text-neutral-500">Senha</label>
                            <input
                                data-testid="login-password"
                                type="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="mt-1 w-full h-12 px-4 bg-white border border-neutral-300 focus:outline-none focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/20"
                            />
                        </div>
                    </div>

                    {error && <div data-testid="login-error" className="mt-4 border border-red-300 bg-red-50 text-red-700 text-sm px-4 py-3 font-mono">{error}</div>}

                    <button
                        data-testid="login-submit"
                        disabled={loading}
                        className="mt-6 w-full h-12 bg-brand-blue text-white font-heading font-bold uppercase tracking-wider hover:bg-brand-blue-hover transition-colors disabled:opacity-60"
                    >
                        {loading ? "entrando…" : "Entrar"}
                    </button>

                    <p className="mt-6 text-xs font-mono text-neutral-400">Admin único · configurado em backend/.env</p>
                </form>
            </div>
        </div>
    );
}
